import { LANGUAGE } from "../../../config/constants";
import { REQUEST, SUCCESS, FAILURE } from "../action-type.util";
export const ACTION_TYPES = {
  CHANGE_LANGUAGE: "CHANGE_LANGUAGE",
};

const initialState = {
  language: localStorage.getItem(LANGUAGE),
  loading: false,
  error: undefined,
};
export const LanguageState = initialState;

export default (state = initialState, action) => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.CHANGE_LANGUAGE):
      return {
        ...state,
        error: undefined,
        loading: true,
      };
    case FAILURE(ACTION_TYPES.CHANGE_LANGUAGE):
      return {
        ...state,
        error: undefined,
        loading: false,
      };
    case SUCCESS(ACTION_TYPES.CHANGE_LANGUAGE):
      return {
        ...state,
        language: action.payload,
        error: undefined,
        loading: false,
      };
    default:
      return state;
  }
};

export const changeLanguage = (language) => async (dispatch) => {
  dispatch({
    type: REQUEST(ACTION_TYPES.CHANGE_LANGUAGE),
  });

  try {
    // Sync locale cookie for help.tamamplus.com (cookie sharing across *.tamamplus.com)
    const locale = language === "ARABIC" ? "ar" : "en";
    document.cookie = `locale=${locale}; path=/; domain=.tamamplus.com; max-age=${60 * 60 * 24 * 365}`;

    dispatch({
      type: SUCCESS(ACTION_TYPES.CHANGE_LANGUAGE),
      payload: language,
    });
  } catch (error) {
    dispatch({
      type: FAILURE(ACTION_TYPES.CHANGE_LANGUAGE),
      payload: error,
    });
  }
};
